import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'initials' })
export class InitialsPipe implements PipeTransform {
  transform(name: string) {
    const [firstName = '', lastName = ''] = name.split(' ');
    return (firstName[0] + lastName[0]).toUpperCase();
  }
}
